import React from 'react';
import { QuestionToAsk, PrintPage, ReturnToHome } from '../../components';
import { IconWarning } from '@americanexpress/dls-react';

function CantApply() {
    const apiOutput = { redirectionUrl: "https://mediacampaigns.americanexpress.com/Home/creditcard"}
    
    return (
        <>
            <div className="flex flex-justify-center">
                <div className="col-xs-12 text-align-center margin-4-t">
                    <IconWarning
                        size="lg"
                        theme={{
                            color: '#a83025 !important',
                            fill: '#a83025 !important'
                        }}
                    />
                </div>
            </div>
           
            <div className="col-xs-12 text-align-center pad-2">
                <p>We appreciate your interest in the American Express® Platinum Reserve Credit Card.
                    Unfortunately, we are not accepting new applications for this Card product at this time.
                    You are welcome to reach back to us for future updates.
                    Thank you for your patience and understanding.</p>
            </div>
            <div className="col-xs-12 text-align-center">
                <div className="pad-4-t">
                    <ReturnToHome apiOutput={apiOutput} />
                    <PrintPage />
                    <QuestionToAsk />
                </div>
            </div>
        </>
    );
}
export default CantApply;